import React from 'react';
//import {authRoles} from '../../auth';

export const ConceptosListConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth: ['admin'],
    routes: [{
        path: '/conceptos-list',
        component: React.lazy(() =>
            import ('./ConceptosList'))
    }]
};